import { Component, Injector, Optional } from '@angular/core';

import { VerzendTarievenPrijzenService } from 'src/app/core/service/verzend-tarieven-prijzen.service';
import { VerzendTarievenPrijzen } from 'src/app/core/dto/verzend-tarieven-prijzen';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';

@Component({
    selector: 'c-i-j-borculo-verzend-tarieven-prijzen-collection',
    templateUrl: './verzend-tarieven-prijzen-collection.component.html'/*,
    styleUrls: ['./verzend-tarieven-prijzen-collection.component.css'] */
})
export class VerzendTarievenPrijzenCollectionComponent extends PagedCollectionComponent<VerzendTarievenPrijzen> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<VerzendTarievenPrijzen>([
		{ colDef: 'prijs', prop: x => x.prijs, searchable: SearchableType.Number },
		{ colDef: 'datum', prop: x => x.datum, searchable: SearchableType.Date }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: VerzendTarievenPrijzenService, @Optional() protected filter: Filter<VerzendTarievenPrijzen>, injector: Injector) {
        super('/verzendTarievenPrijzen/verzendTarievenPrijzen', injector, VerzendTarievenPrijzen);

        this.filter.onGetChipLabel(x => x.prijs, () => 'Prijs');
		this.filter.onGetChipLabel(x => x.datum, () => 'Datum'); 
    }

    canDelete() {
        return false;
    }
}